var exports = {
  "wm": "xa15a2ab7--6af76f--logo",
  "_8": "xa15a2ab7--6af76f--img",
  "Pf": "xa15a2ab7--6af76f--label",
  "O0": "xa15a2ab7--6af76f--rating",
  "cL": "xa15a2ab7--6af76f--builder",
};

module.exports = exports;
